import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import KpiDashboard from '../../kpi/KpiDashboard';//eslint-disable-line import/no-named-as-default
import Resources from '../../resourceLinks/ResourceLinks';
import Conversation from '../../conversationDialog/ChildConversationDialog';
import Image from '../../image/SecondaryImage';
import AudioControls from "../../audio/SimpleAudioController";
import * as trackingDataActions from '../../../../actions/trackingDataActions';
import * as userDataActions from '../../../../actions/userDataActions';
import * as appHelper from '../../../../helpers/appHelper';
import * as appConstants from '../../../../constants/appConstants';
import * as objectConstants from '../../../../constants/objectConstants';
import * as kpiConstants from '../../../../constants/kpiConstants';
import * as imageHelper from '../../../../helpers/imageHelper';
import * as assetConstants from '../../../../constants/assetConstants';
import * as animationHelper from "../../../../helpers/animationHelper";

class ConversationSingleAnswerFeedbackReview extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            option: this.props.option,
            locale: appHelper.getLocalData(this.props.option),
            assets: {
                character: {
                    src: "",
                    type: "",
                    type_id: ""
                }
            },
            showResponse: false,
            showFeedbackContent: false,
            showKpis: appHelper.isDefined(this.props.option.kpis) && this.props.option.kpis !== null,
            kpiDashboardParams: {
                responseReview: true,
                showTitle: false,
                showImmediateImpact: true,
                allowUpdates: false
            },
            hasDialogs: appHelper.isDefined(this.props.option.dialogs) && this.props.option.dialogs.length > 0,
            dialogComplete: !appHelper.isDefined(this.props.option.dialogs) || this.props.option.dialogs.length === 0,
            callbacks: {},
            resourceLinks: [],
            hasResources: false,
            resourcesAreComplete: true,
            hasLeftAsset: appHelper.isDefined(this.props.option.feedback_settings.left) && this.props.option.feedback_settings.left.constant !== assetConstants.ASSET_TYPE_METRIC_RESULT,
            hasRightAsset: appHelper.isDefined(this.props.option.feedback_settings.right) && this.props.option.feedback_settings.right.constant !== assetConstants.ASSET_TYPE_METRIC_RESULT,
            hasTopAsset: appHelper.isDefined(this.props.option.feedback_settings.top) && this.props.option.feedback_settings.top.constant !== assetConstants.ASSET_TYPE_METRIC_RESULT,
            hasBottomAsset: appHelper.isDefined(this.props.option.feedback_settings.bottom) && this.props.option.feedback_settings.bottom.constant !== assetConstants.ASSET_TYPE_METRIC_RESULT,
            imageStyles: {},
            imageClass: "",
            updateImageStyles: false,
            imageStylesSet: false,
            feedbackAsset: {
                src: ""
            },
            feedbackAssetData: {},
            creditLabel: `${appHelper.getLocaleString("credit_label")}`,
            refValue: `${this.props.option.option_id}_feedbackWrapper`,
            audio: {
                src: "",
            },
            allowAudioAutoPlay: false,
            showLabels: true,
            showAnimation: false,
        };
        this.getAssets = this.getAssets.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
        this.show = this.show.bind(this);
        this.onFeedbackRevealed = this.onFeedbackRevealed.bind(this);
        this.showFeedbackContent = this.showFeedbackContent.bind(this);
        this.showKpiDashboard = this.showKpiDashboard.bind(this);
        this.dialogsOnComplete = this.dialogsOnComplete.bind(this);
        this.setCallbacks = this.setCallbacks.bind(this);
        this.onResourcesComplete = this.onResourcesComplete.bind(this);
        this.setResources = this.setResources.bind(this);
        this.getInheritedFeedback = this.getInheritedFeedback.bind(this);
        //new

        this.setClass = this.setClass.bind(this);
        this.setIconClass = this.setIconClass.bind(this);
        this.getImageStyles = this.getImageStyles.bind(this);
        this.getAssetType = this.getAssetType.bind(this);

        this.feedbackPanel =  React.createRef();
        this.contentWrapper =  React.createRef();
    }

    componentDidMount() {
        this.getAssets();
        this.setCallbacks();
        this.setResources();
        this.getImageStyles();
        this.show();
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.lang !== nextProps.lang) {
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.option),
                creditLabel: `${appHelper.getLocaleString("credit_label")}`

            });
        }
        if (this.state.locale !== nextProps.locale) {
            this.setState({locale: Object.assign({}, nextProps.locale)});
        }
    }

    componentDidUpdate() {
        if (!this.state.imageStylesSet) {
            this.getImageStyles();
        }
    }

    getAssets() {
        let feedbackAsset = {};
        let feedbackAssetData = {};

        if (this.state.hasLeftAsset) {
            feedbackAsset = this.getAssetType(this.state.option.feedback_settings.left);
            feedbackAssetData = Object.assign({}, this.state.option.feedback_settings.left);
        } else if (this.state.hasRightAsset) {
            feedbackAsset = this.getAssetType(this.state.option.feedback_settings.right);
            feedbackAssetData = Object.assign({}, this.state.option.feedback_settings.right);
        } else if (this.state.hasTopAsset) {
            feedbackAsset = this.getAssetType(this.state.option.feedback_settings.top);
            feedbackAssetData = Object.assign({}, this.state.option.feedback_settings.top);
        } else if (this.state.hasBottomAsset) {
            feedbackAsset = this.getAssetType(this.state.option.feedback_settings.bottom);
            feedbackAssetData = Object.assign({}, this.state.option.feedback_settings.bottom);
        }

        if (feedbackAssetData.constant === assetConstants.ASSET_TYPE_IMAGE) {
            feedbackAssetData = Object.assign({}, feedbackAssetData, {
                allow_diagram_zoom: this.state.option.feedback_settings.allow_diagram_zoom,
                show_diagram_title: this.state.option.feedback_settings.show_diagram_title,
                show_diagram_description: this.state.option.feedback_settings.show_diagram_description,

            });
        }

        if (appHelper.isDefined(this.state.option.audio) && appHelper.isDefined(this.state.locale.audio)) {
            let audio = appHelper.getAudioAsset(this.state.locale.audio);
            if (appHelper.isDefined(this.state.option.audio.enabled) && this.state.option.audio.enabled) {
                if (appHelper.isDefined(this.state.option.audio.show_audio_controls) && this.state.option.audio.show_audio_controls) {
                    this.setState({
                        audio: Object.assign({}, audio),
                    });
                }/* else {
                    let audioObj = {
                        audioRef: `audio_${audio.id}_${audio.type}`,
                    };
                    if (appHelper.isDefined(this.props.actions.setAudio) && appHelper.isDefined(this.state.option.audio.auto_play) && this.state.option.audio.auto_play) {
                        this.props.actions.setAudio(audioObj);
                    }
                }*/
            }
        }

        this.setState({
            feedbackAsset: Object.assign({}, feedbackAsset),
            feedbackAssetData: Object.assign({}, feedbackAssetData),
        });
    }

    getAssetType(asset) {
        let returnAsset = {};
        if (asset.constant === assetConstants.ASSET_TYPE_ICON) {
            returnAsset = appHelper.getIconAsset(asset);
        } else if (asset.constant === assetConstants.ASSET_TYPE_IMAGE) {
            returnAsset = appHelper.getImageAsset(asset);

        } else if (asset.constant === assetConstants.ASSET_TYPE_LIBRARY_IMAGE) {
            returnAsset = appHelper.getLibraryImageAsset(asset);
        } else if (asset.constant === assetConstants.ASSET_TYPE_ID_CHARACTER) {
            let characterAsset = appHelper.getCharacterAsset(asset);
            returnAsset = appHelper.getCharacterPose(characterAsset, asset);
        } else if (asset.constant === assetConstants.ASSET_TYPE_METRIC_RESULT) {
            returnAsset = Object.assign({}, asset);
        }
        returnAsset = appHelper.isDefined(returnAsset.locale) ? appHelper.getLocalData(returnAsset) : returnAsset;

        if (appHelper.isDefined(asset.constant) && !appHelper.isDefined(returnAsset.type)) {
            returnAsset = Object.assign({}, returnAsset, {
                type: asset.constant
            });
        }

        return returnAsset;
    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }

    show() {
        let feedbackPanel = this.feedbackPanel.current;//this.refs[`${this.state.option.option_id}_feedbackPanel`];
        /*if (appHelper.isDefined(feedbackPanel) && feedbackPanel !== null) {
            TweenLite.set(feedbackPanel, {height: "auto", opacity: 1});

            TweenLite.from(feedbackPanel, objectConstants.FEEDBACK_DURATION, {
                height: 0,
                opacity: 0,
                ease: Linear.easeIn
            }).eventCallback("onComplete", this.onFeedbackRevealed);
        }*/

        let params = {
            ele: feedbackPanel,
            duration: objectConstants.FEEDBACK_DURATION,
            delay: 0,
            callback: this.onFeedbackRevealed
        };
        animationHelper.showHeight(params);
    }

    onFeedbackRevealed() {
        if (appHelper.isDefined(this.state.locale.character_response) && this.state.locale.character_response.length > 0) {
            this.setState({showResponse: true});
        } else {
            this.showFeedbackContent();
        }
    }

    showFeedbackContent() {
        this.setState({showFeedbackContent: true, showKpis: appHelper.isDefined(this.state.option.kpis) && this.state.option.kpis !== null});
    }

    showKpiDashboard() {

    }

    dialogsOnComplete() {
        this.setState({dialogComplete: true});
        this.show();
    }

    setCallbacks() {

    }

    setResources() {
        let resourceLinks = appHelper.setResourceLinks(this.state.option);
        let hasRequiredResources = appHelper.hasRequiredResources(resourceLinks);
        this.setState({
            resourceLinks: Object.assign([], resourceLinks),
            hasResources: resourceLinks.length > 0,
            resourcesAreComplete: resourceLinks.length === 0 || !hasRequiredResources
        });

    }

    onResourcesComplete() {
        if (!this.state.resourcesAreComplete) {
            this.setState({resourcesAreComplete: true, checkComplete: true});
        }
    }

    getInheritedFeedback(feedback_id) {
        let option = appHelper.getArrayObjectByKey(this.props.options, "option_id", feedback_id);
        let optionLocale = appHelper.getLocalData(option);
        return optionLocale.feedback;
    }

    setClass() {

        let className = "";
        if (appHelper.isDefined(this.state.option.feedback_settings.class_name) && this.state.option.feedback_settings.class_name.length > 0) {
            className += ` ${this.state.option.feedback_settings.class_name}`;
        } else {
            className += "standard-block";
        }

        if (appHelper.isDefined(this.state.option.feedback_settings.bullet_list_style) && this.state.option.feedback_settings.bullet_list_style !== null) {
            className += ` ${this.state.option.feedback_settings.bullet_list_style}`;
        }
        return className;
    }

    setIconClass() {
        let iconClass = '';

        if (this.state.hasLeftAsset) {

            iconClass += 'left-asset ';
        } else if (this.state.hasRightAsset) {
            iconClass += 'right-asset ';
        } else if (this.state.hasTopAsset) {
            iconClass += 'top-asset ';
        } else if (this.state.hasBottomAsset) {
            iconClass += 'bottom-asset ';
        }

        /*if (this.state.screenAsset.type === assetConstants.ASSET_TYPE_ICON) {
            iconClass += 'icon ';
        } else {
            iconClass += 'image ';
        }*/

        if (this.state.feedbackAssetData.constant === assetConstants.ASSET_TYPE_IMAGE) {
            iconClass += 'image ';
        }
        return iconClass;
    }

    getImageStyles() {
        let refValue = this.contentWrapper.current;
        if (appHelper.isDefined(refValue) && refValue !== null && appHelper.isDefined(this.state.feedbackAsset.src) && this.state.feedbackAsset.src.length > 0) {
            let assetStyles = imageHelper.checkAssetImageWidth(this.state.option.feedback_settings, this.state.feedbackAsset, refValue.offsetWidth).styles;
            this.setState({
                updateImageStyles: false,
                imageStylesSet: true,
                imageStyles: Object.assign({}, assetStyles),
                imageClass: imageHelper.getAssetImageClass(this.state.option.feedback_settings),
            });
        }
    }

    render() {
        return (
            <div className="clear-both">
                {this.state.hasDialogs
                    ?
                    <Conversation asset_id={this.props.asset_id} option_id={this.state.option.option_id}
                                  dialogs={this.state.option.dialogs} callbacks={this.state.callbacks}
                                  onComplete={this.dialogsOnComplete}/>
                    :
                    null
                }

                {this.state.dialogComplete && (appHelper.isDefined(this.state.locale.feedback) || this.state.showKpis || this.state.hasResources) || appHelper.isDefined(this.state.option.feedback_id)
                    ?
                    <div className="a-c" ref={this.feedbackPanel}>
                        <div className={`feedback-panel ${this.state.option.result} review`}
                             ref={`${this.state.option.option_id}_feedbackPanel`}>
                            <div className="feedback-content-col">
                                {this.state.showKpis && appHelper.isDefined(this.state.option.kpis) && this.state.option.kpis !== null
                                    ? <KpiDashboard displayState={kpiConstants.KPI_DISPLAY_STATE_REVIEW_POINTS_AWARDED}
                                                    bite_id={this.props.responseData.bite_id}
                                                    screen_id={this.props.responseData.screen_id}
                                                    asset_id={this.props.responseData.asset_id}
                                                    option={this.props.option}
                                                    responseReview={this.state.kpiDashboardParams.responseReview}
                                                    showImmediateImpact={this.state.kpiDashboardParams.showImmediateImpact}
                                                    showTitle={this.state.kpiDashboardParams.showTitle}/>
                                    : null
                                }

                                <div className={`paragraph-content-wrapper ${this.setIconClass()}`}
                                     ref={this.contentWrapper}>


                                    {this.state.hasLeftAsset || this.state.hasTopAsset
                                        ?
                                        <div className="asset-column">
                                            {this.state.feedbackAssetData.constant === assetConstants.ASSET_TYPE_IMAGE && this.state.imageStylesSet
                                            &&
                                            <Image screenObject={this.state.feedbackAssetData}
                                                   imageClass={this.state.imageClass}
                                                   imageStyles={this.state.imageStyles}/>

                                            }
                                            {this.state.feedbackAssetData.constant !== assetConstants.ASSET_TYPE_IMAGE && this.state.imageStylesSet
                                            &&
                                            <div className={`asset-image-wrapper ${this.state.imageClass}`}
                                                 style={this.state.imageStyles}>
                                                <img src={this.getImagePath(this.state.feedbackAsset.src)} alt=""/>
                                            </div>
                                            }

                                            {appHelper.isDefined(this.state.feedbackAsset.credit) && this.state.feedbackAsset.credit.length > 0 &&
                                            <div className={`image-credit`}
                                                 style={this.state.imageStyles}>{this.state.creditLabel}: {this.state.feedbackAsset.credit}</div>
                                            }


                                        </div>
                                        :
                                        null
                                    }
                                    <div className="content-column">
                                        {appHelper.isDefined(this.state.locale.feedback) && this.state.locale.feedback.length > 0
                                            ? <div className="object-container"
                                                   dangerouslySetInnerHTML={{__html: this.state.locale.feedback}}/>
                                            :
                                            appHelper.isDefined(this.state.option.feedback_id)
                                                ?
                                                <div className="object-container"
                                                     dangerouslySetInnerHTML={{__html: this.getInheritedFeedback(this.state.option.feedback_id)}}/>
                                                :
                                                null
                                        }
                                        {
                                            appHelper.isDefined(this.state.option.audio) && appHelper.isDefined(this.state.option.audio.show_audio_controls) && this.state.option.audio.show_audio_controls && appHelper.isDefined(this.state.audio.id)
                                                ?
                                                <AudioControls audio={this.state.audio}
                                                               autoPlay={this.state.allowAudioAutoPlay}
                                                               showLabels={this.state.showLabels}
                                                               showAnimation={this.state.showAnimation}
                                                               audioRef={`text_audio_${this.state.option.asset_id}_${this.state.audio.id}_${this.state.audio.constant}`}/>
                                                :
                                                null
                                        }
                                        {
                                            this.state.hasResources
                                                ?
                                                <Resources resources={this.state.resourceLinks}
                                                           onResourcesComplete={this.onResourcesComplete}/>
                                                :
                                                null
                                        }
                                    </div>
                                    {this.state.hasRightAsset || this.state.hasBottomAsset
                                        ?
                                        <div className="asset-column">
                                            {this.state.feedbackAssetData.constant === assetConstants.ASSET_TYPE_IMAGE && this.state.imageStylesSet
                                            &&
                                            <Image screenObject={this.state.feedbackAssetData}
                                                   imageClass={this.state.imageClass}
                                                   imageStyles={this.state.imageStyles}/>
                                            }
                                            {this.state.feedbackAssetData.constant !== assetConstants.ASSET_TYPE_IMAGE && this.state.imageStylesSet
                                            &&
                                            <div className={`asset-image-wrapper ${this.state.imageClass}`}
                                                 style={this.state.imageStyles}>
                                                <img src={this.getImagePath(this.state.feedbackAsset.src)} alt=""/>


                                            </div>
                                            }
                                            {appHelper.isDefined(this.state.feedbackAsset.credit) && this.state.feedbackAsset.credit.length > 0 &&
                                            <div className={`image-credit`}
                                                 style={this.state.imageStyles}>{this.state.creditLabel}: {this.state.feedbackAsset.credit}</div>
                                            }


                                        </div>
                                        :
                                        null
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    : null
                }
            </div>
        );
    }
}

ConversationSingleAnswerFeedbackReview.propTypes = {
    option: PropTypes.object.isRequired,
    options: PropTypes.array.isRequired,
    locale: PropTypes.object,
    responseData: PropTypes.object.isRequired,
    asset_id: PropTypes.number.isRequired,
    callbacks: PropTypes.object,
    onComplete: PropTypes.func,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object
};

ConversationSingleAnswerFeedbackReview.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state) {
    let lang = state.userData.lang;
    return {
        lang: lang,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, trackingDataActions, userDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ConversationSingleAnswerFeedbackReview);



/** WEBPACK FOOTER **
 ** ./src/components/objects/multipleChoice/conversationSingleAnswer/ConversationSingleAnswerFeedbackReview.js
 **/